import React, { useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import shortid from 'shortid'
import { bindActionCreators } from "redux";
import cookieOperator from 'cookie-operator';

import "./FormLogin.scss";
import messages from "../../assets/i18n";
import { ButtonStandard } from "../../components";
import getEnvParam from "../../utils/getEnvParam";
import { Creators as actionAuthentication } from "../../store/ducks/authentication";

function FormLogin (props) {

	const dispatch = useDispatch();

	const authentication = useSelector(state => state.authentication);
	const authorization = useSelector(state => state.authorization);
	const lang = useSelector(state => state.language.name);
	const setClientId = useCallback(() => {
		bindActionCreators(actionAuthentication.setClientId, dispatch)
	}, [dispatch]);

	useEffect(() => {
		if (authentication.status !== 'logged_in') {
			const clientIdGenerated = shortid.generate();
			const configCookie = {
				domain: 'lojasrenner.com.br',
				sameSite: 'strict',
			};
			setClientId(clientIdGenerated);
			cookieOperator.remove('clientId', configCookie);
			cookieOperator.set('clientId', clientIdGenerated, configCookie);
		}
	}, [setClientId, authentication.status]);

	useEffect(() => {
		const { status, token } = authentication;
		const { permissions } = authorization;
		if (status === "logged_in" || (token && permissions.length)) {
			props.history.push(`/main`);
		}
	}, [authentication, authorization, props.history]);

	const handleLogin = () => {
		window.location.href = getEnvParam('REACT_APP_URL_LOGIN') + 'login';
	}

	return (
		<form>
			<div className="form-group-button">
				<ButtonStandard
					id="login_login_button"
					text={messages[lang].Login}
					textId={messages[lang].login}
					className="btn-login btn-rounded mt-2 btn-hover"
					type="button"
					onClick={handleLogin}
				/>
			</div>
		</form>
	);
}

// export for testing and storybook
export const FormLoginWithoutWithRouter = FormLogin;

// export for use
export default withRouter(FormLogin);
